import resolveComponent from '../resolveComponent';

const AIWriterConfig = [
  {
    path: `/:appId?/ai-writer`,
    label: '智能写作',
    exact: false,
    component: resolveComponent(() => import('@src/service')),
    children: [
      {
        path: `/:appId?/ai-writer/editor`,
        exact: true,
        label: '智能小编',
        component: resolveComponent(() => import('@src/pages/app/AIEditor')),
      },
      {
        path: `/:appId?/ai-writer/poster`,
        exact: true,
        label: 'AI海报',
        component: resolveComponent(() => import('@src/pages/app/AIPoster')),
      },
    ],
  },
];

export default AIWriterConfig;
